import { Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";

const SignUp = () => {
  return (
    <Nav.Item>
      <Nav.Link href="/signup">Sign Up</Nav.Link>
    </Nav.Item>
  )
}

export default SignUp;